module.exports = __webpack_public_path__ + "img/mall91_icon.d49ebc27.png";